import createAPI from '@common/createAPI.js'

export default {
  // 信源分类
  postSourceCate: config =>
    createAPI('/api/source/categories', 'post', config, {}),
  // 地域列表
  postRegions: config => createAPI('/api/regions', 'post', config, {}),
  // 媒体机构所属省市
  postMediaRegion: config => createAPI('/api/media/region', 'post', config),
  // 开放接口v3-报刊浏览列表
  postEpaperList: config => createAPI('/api/epaper/list', 'post', config),
  // 开放接口v3-版面详情
  postEpaperLayouts: config => createAPI('/api/epaper/layouts', 'post', config),
  // 稿件详情
  postSpcialDetail: config => createAPI('/mbd-special/special/detail', 'post', config),
  // 稿件列表详情
  postSpcialDetails: config => createAPI('/mbd-special/special/details', 'post', config)
}
